import { useCallback } from 'react'

import useSWR from 'swr'

// import useSWRInfinite from 'swr/infinite'
import { MeetingsAPI } from 'api/index'

export interface MeetingBookedByMe {
  eventId: string
  agentId: number | null
  endUserId: number | null
  endUserName: string
  endUserAvatar: string
  companyName: string
  contactUrl: string
  accountUrl: string
  status: string
  scheduledAt: number
  startTime: number
  endTime: number
  meetingSource: string
  bookedTeammateNames: string[]
}

interface ReportResponse {
  rows: MeetingBookedByMe[]
  totalRowCount: number
}

const getBaseUrl = (limit: number, offset: number) => {
  return `/meeting/report?limit=${limit}&offset=${offset}`
}

const fetcher = (url: string) => {
  return MeetingsAPI.get(url).then((res) => {
    return res.data
  })
}

export default function useMeetingsBookedByMe(
  pageIndex: number,
  pageSize: number
) {
  const { data, isLoading } = useSWR<ReportResponse>(
    getBaseUrl(pageSize, pageIndex * pageSize),
    fetcher
  )

  const updateStatus = useCallback((eventId: string, newValue: string) => {
    MeetingsAPI.post(`/meeting/status/${eventId}`, `"${newValue}"`)
  }, [])

  return {
    updateStatus,
    meetingsData: data,
    isLoading,
  }
}
